import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Stack, TextField, Theme, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { makeStyles } from 'tss-react/mui';
import { isNullOrUndefined } from 'app/helpers/objectHelpers';

export const MiscellaneousDescription = ({
  isModEdit,
  showMiscDescription,
}: {
  isModEdit: boolean;
  showMiscDescription: any;
}) => {
  const { t } = useTranslation();
  const { control, getValues, formState: { errors }, setError, clearErrors } = useFormContext();
  const useStyles = makeStyles()((theme: Theme) => ({
    textField: {
      '& .MuiFilledInput-root': {
        backgroundColor: 'rgba(0,0,0,0.04)',
      },
      '& .MuiFilledInput-root:hover': {
        backgroundColor: 'rgba(0,0,0,0.04)',
        '@media (hover: none)': {
          backgroundColor: 'rgba(0,0,0,0.04)',
        },
      },
      '& .MuiFilledInput-root.Mui-disabled': {
        backgroundColor: 'rgba(0,0,0,0.04)',
      },
      '& .MuiFilledInput-root.Mui-disabled:before': {
        borderBottomStyle: 'solid',
      },
      '& .MuiFilledInput-root:hover.Mui-disabled:before': {
        borderBottom: '1px solid gray !important',
      },
    },
  }));
  const { classes } = useStyles();
  let initialState = true;
  useEffect(() => {
    if (isModEdit && isNullOrUndefined(getValues('description')) && initialState) {
      setError('initialDescription', {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getValues('description')]);
  return (
    <Grid>
      <Grid item xs={12}>
        <>
          <Controller
            name="description"
            control={control}
            rules={{
              required: showMiscDescription(),
            }}
            render={({ field: { onChange, ...rest } }) => (
              <Stack sx={{ verticalAlign: 'unset' }}>
                <TextField
                  multiline
                  className={classes.textField}
                  value={getValues('description')}
                  variant="filled"
                  maxRows={5}
                  inputProps={{ maxLength: 255 }}
                  disabled={!isModEdit}
                  error={!!errors?.description}
                  helperText={!isNullOrUndefined(errors?.description) ? 'Required' : undefined}
                  label={`${t('placement.placementMods.miscellaneousDescription')}*`}
                  onChange={e => {
                    onChange(e);
                    initialState = false;
                    clearErrors('initialDescription');
                  }}
                  InputProps={{
                    readOnly: !isModEdit,
                  }}
                  {...rest}
                />
                <Typography sx={{ textAlign: 'right', fontSize: '11px', color: '#707070' }} component="span">
                  {(getValues('description') ? getValues('description').length.toString() : '0') + '/255'}
                </Typography>
              </Stack>
            )}
          />
        </>
      </Grid>
    </Grid>
  );
};
